/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ status: NonNullable<unknown> }} Iframe_Remote_Subtitle_Fetch_Failed_ErrorInputs */



/**
* | output |
* | --- |
* | "Failed to fetch subtitle file: {status}" |
*
* @param {Iframe_Remote_Subtitle_Fetch_Failed_ErrorInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iframe_remote_subtitle_fetch_failed_error = /** @type {((inputs: Iframe_Remote_Subtitle_Fetch_Failed_ErrorInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iframe_Remote_Subtitle_Fetch_Failed_ErrorInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Echec de recuperation du fichier de sous-titres : ${i?.status}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Untertiteldatei konnte nicht abgerufen werden: ${i?.status}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Impossibile recuperare il file dei sottotitoli: ${i?.status}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Не удалось загрузить файл субтитров: ${i?.status}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`No se pudo obtener el archivo de subtítulos: ${i?.status}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`获取字幕文件失败：${i?.status}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`字幕ファイルの取得に失敗しました: ${i?.status}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`उपशीर्षक फ़ाइल प्राप्त करने में विफल: ${i?.status}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Falha ao obter o arquivo de legenda: ${i?.status}`)
	return /** @type {LocalizedString} */ (`Failed to fetch subtitle file: ${i?.status}`)
});